<template>
   <div class="ui-content dashboard">
        <v-card class="mx-auto normal-card subscription-details">
            <div class="subscription-padding">
                <div class="subscription-details-title">Subscription Details:</div>
                <template v-if="!subscriptionNewModules || !subscriptionNewModules.length">
                    <div class="subscription-details-btm-border">
                        <div class="subscription-details-row">
                            <div class="subscription-details-col">
                                <div class="subscription-details-label">Number of Student Licenses:</div>
                                <div class="subscription-details-info">{{subscription_data.student_count}}</div>
                            </div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label-1">Licenses Valid Till:</div>
                                <div class="subscription-details-info">{{allowed_end_date}}</div>
                            </div>
                            <div class="subscription-details-col">&nbsp;</div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label">Active Students:</div>
                                <div class="subscription-details-info">{{user.total_active_student}}</div>
                            </div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label-1">Unused Licenses:</div>
                                <div class="subscription-details-info">{{user.student_remaining_licenses}}</div>
                            </div>
                            <div class="subscription-details-col">&nbsp;</div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label">Deactivated Students:</div>
                                <div class="subscription-details-info">{{user.total_deactive_student}}</div>
                            </div>
                            <div class="subscription-details-col">
                                <div class="subscription-details-label-1">Monthly Licensing Fee:</div>
                                <div class="subscription-details-info">  ₹{{subscription_data.monthly_license_fee}} </div>
                                <!-- <div class="subscription-details-info">₹{{subscription_data.monthly_license_fee}}</div> -->
                            </div>
                            <div class="subscription-details-col">&nbsp;</div>
                        </div>
                    </div>
                    <div class="two-btn-outer">
                        <v-btn class=" cust-btn btn-1" @click="renewButton()" color="primary">Renew/Extend Subscription</v-btn>
                        <v-btn class=" cust-btn second-btn" :disabled='isDisabled' @click="purchaseButton()" color="primary">Purchase More Licenses</v-btn>
                    </div>
                </template>
                <template v-else>
                    <div class="subscription-details-btm-border" v-for="subInfo in subscriptionNewModules">
                        <h5>{{subInfo.description}}</h5>
                        <div class="subscription-details-row">
                            <template v-if="Number(subInfo.no_of_licences)">
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Number of Student Licenses:</div>
                                    <div class="subscription-details-info">{{subInfo.no_of_licences}}</div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Licenses Valid Till:</div>
                                    <div class="subscription-details-info">{{subInfo.allowed_end_date}}</div>
                                </div>
                               <div class="subscription-details-col">&nbsp;</div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Active Students:</div>
                                    <div class="subscription-details-info">{{subscription_data.students_active}}</div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Unused Licenses:</div>
                                    <div class="subscription-details-info">{{subInfo.unused_licenses}}</div>
                                </div>
                                <div class="subscription-details-col">&nbsp;</div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Deactivated Students:</div>
                                    <div class="subscription-details-info">{{subscription_data.students_deactive}} </div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Annual Licensing Fee:</div>
                                    <div class="subscription-details-info">  ₹{{subInfo.per_student_amount}} </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Valid Till:</div>
                                    <div class="subscription-details-info">{{subInfo.allowed_end_date}}</div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Total Amount:</div>
                                    <div class="subscription-details-info">  ₹{{subInfo.total_amount}} </div>
                                </div>
                                <div class="subscription-details-col">&nbsp;</div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Allowed Downloads per Month:</div>
                                    <div class="subscription-details-info">  {{subInfo.no_of_test_downloads}} </div>
                                </div>
                                <div class="subscription-details-col">
                                    <div class="subscription-details-label">Downloads this Month:</div>
                                    <div class="subscription-details-info">  {{subscription_data.total_downloads || 0}} </div>
                                </div>
                            </template>
                            <div class="subscription-details-col">&nbsp;</div>
                            <div class="subscription-details-col" v-if="subInfo.is_renewable">
                                <v-btn class=" cust-btn btn-1" @click="renewButton(subInfo.module_id)" color="primary" style="margin-right: 20px">Renew/Extend Subscription</v-btn>
                                <v-btn v-if="Number(subInfo.no_of_licences)" class=" cust-btn second-btn" :disabled='subInfo.is_disabled' @click="purchaseButton(subInfo.module_id)" color="primary">Purchase More Licenses</v-btn>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="contact-outer">
                    <div class="subscriptio-contact renew-screen-fix">
                        For any assistance contact us at <a class="italics-styling"
                                        href="mailto: hello@eduracle.com"
                                    > 'hello@eduracle.com'</a>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment, { now } from "moment";

export default {
    name: "Subscription",
    mounted() {
        this.getInstituteDetails();
        if (localStorage.getItem("myInstitute")) {
        this.subscription_data = JSON.parse(localStorage.getItem("myInstitute"));
        this.allowed_end_date = moment(`${this.subscription_data.expiry_date}`).format(
        "DD - MMM - YYYY" 
      );

		var now = new Date();
		var expiry_date = new Date(this.subscription_data.expiry_date)
		this.isDisabled = !(expiry_date.getTime()>=now.getTime())
    	}
    },
     data() {
    return {
        subscription_data: {},
        allowed_end_date: "",
		isDisabled:false
    };
  },
    methods: {
        ...mapActions({
            getInstituteDetails: "userStore/getInstituteDetails",
        }),
        renewButton(moduleId) {
            sessionStorage.setItem("renewModule", moduleId);
            this.$router.push({name: 'renew-subscription'})
        },
        purchaseButton(moduleId) {
            sessionStorage.setItem("purchaseModule", moduleId);
            this.$router.push({name: 'purchase-subscription'})
        }
     },
  computed: {
    ...mapState("userStore", ["user"]),
    subscriptionNewModules() {
        if (!this.subscription_data.selected_new_module || !this.subscription_data.selected_new_module.length) return [];
        const now = moment();

        return this.subscription_data.selected_new_module.map(subInfo => {
            const endDate = moment(subInfo.expiry_date);

            return {
                allowed_end_date: endDate.format("DD - MMM - YYYY"),
                is_disabled: (subInfo.name == 'AITS' && this.subscription_data.hasSLM) ? false : endDate.isBefore(now),
                ...subInfo,
            };
        });
    },
  },
};
</script>
